<template>
    <div class="container">
      <div class="credit-explainer">
        <h2>🐾 StingyCat's Credit Score Class 🐾</h2>
        <p>Hey Feline Fanatics! Curious about your credit score? Let me guide you through the mysterious jungle of credit scores! Let's paw-ruse these 5 elements that shape your score:</p>
        <div v-for="(section, index) in creditSections" :key="index" class="credit-section">
          <h3>{{ section.title }}</h3>
          <p>{{ section.explanation }}</p>
        </div>
      </div>
    </div>
    <div class="stylish-links">
            <h3>🔗 Important Links 🖇️</h3>
            <ul>
              <li><a href="https://my.equifax.ca/consumer-registration/?lang=en" target="_blank">Free Equifax Credit Report</a></li>
              <li><a href="https://www.transunion.ca/product/consumer-disclosure#articleSection4" target="_blank">Free TransUnion credit report</a></li>
              <li><a href="https://www.consumer.equifax.ca/personal/dispute-credit-report/" target="_blank">Dispute information on your Equifax credit report</a></li>
              <li><a href="https://www.transunion.ca/assistance/credit-report-disputes" target="_blank">Dispute information on your Transunion credit report</a></li>
              
            </ul>
          </div><br><br><br><br><br><br>
  </template>
  
  <script setup>
  import { ref } from 'vue';
  
  const creditSections = ref([
    { 
      title: "Payment History (35%) 🕰️💵 ", 
      explanation: "Ever forget to feed your kitty? Bad hooman! Paying on time is like feeding me on time. If you don't, I'll remember. And so will your credit score. " 
    },
    {
      title: "How Much is Owed (30%) 🎒💰",
      explanation: "Imagine your backpack full of catnip. Too much, and you can't carry it! Too much debt is the same; it makes you wobbly in the eyes of lenders."
    },
    {
      title: "Length of Credit History (15%) 📅🎈",
      explanation: "The longer we've been pals, the better I understand your treat-giving habits. Similarly, a long credit history shows you're a responsible hooman."
    },
    {
      title: "New Credit Applications (10%) 🛒💳",
      explanation: "Ever seen a kitten chasing too many toys at once? That's you applying for too much credit. Slow down, speedy whiskers!"
    },
    {
      title: "Types of Credit Used (10%) 🃏🔑",
      explanation: "A mix of toys keeps me entertained. Same goes for credit; a blend is good but manage it wisely!"
    }
  ]);
  </script>
  
  <style scoped>
  .credit-explainer {
    background-color: #f4f4f4;
    padding: 20px;
    border-radius: 10px;
  }
  
  .credit-section {
    margin-bottom: 20px;
  }
  </style>
    
  
  <style scoped>
  .container {
    background-color: #4A148C;
    color: black;
    padding: 20px;
    border-radius: 20px;
  }
  
  
  .content {
    background-color: white;
    padding: 20px;
    border-radius: 10px;
    color: black;
  }
  .stylish-links {
    background: linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(240,240,240,1) 100%);
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  }
  
  .stylish-links h3 {
    color: #333;
    font-size: 1.4em;
    margin-bottom: 15px;
  }
  
  .stylish-links ul {
    list-style: none;
    padding: 0;
  }
  
  .stylish-links ul li {
    background-image: linear-gradient(135deg, #6D5BBA 0%, #8D58BF 100%); /* Apply the same gradient as your app theme */
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 5px;
  margin: 5px;
  cursor: pointer;
  transition: background-color 0.3s, box-shadow 0.3s;
  }
  
  .stylish-links ul li a {
    color: white;
    text-decoration: none;
    font-weight: bold;
  }
  
  .stylish-links ul li:hover {
    background-image: linear-gradient(135deg, #8D58BF 0%, #6D5BBA 100%); /* Slightly adjust gradient for hover effect */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2); /* Add a shadow for depth */
  }
  
  .stylish-links ul li:hover a {
    color: #fff;
  }
  </style>
  
  